import { useCallback } from 'react';

import type { SortOption } from '../models';
import { useSortingOptions } from './use-sorting-options';
import { useTariffSearchFilters } from './use-tariff-search-filters';

export const useTariffsControls = () => {
  const { tariffsSearchParams, setFilters } = useTariffSearchFilters();

  const { data: sortOptions = [] } = useSortingOptions();

  const changeSort = useCallback(
    (option: SortOption | null) => {
      if (!option) {
        return;
      }
      setFilters({
        sorting: option.id,
      });
    },
    [setFilters],
  );

  const deleteTariffs = useCallback(() => {
    console.log('Delete selected tariffs');
  }, []);

  const classRate = useCallback(() => {
    console.log('Mark as class rate tariff');
  }, []);

  const changeEffectiveDates = useCallback(() => {
    console.log('Change effective dates');
  }, []);

  const exportTariffs = useCallback(() => {
    console.log('Export tariffs');
  }, []);

  const addTariff = useCallback(() => {
    console.log('Add tariff');
  }, []);

  // todo compute disabled flags based on selected items
  const isDeleteDisabled = true;
  const isClassRateDisabled = true;
  const isChangeDatesDisabled = true;
  const isExportDisabled = true;

  return {
    addTariff,
    changeEffectiveDates,
    changeSort,
    classRate,
    deleteTariffs,
    exportTariffs,
    isChangeDatesDisabled,
    isClassRateDisabled,
    isDeleteDisabled,
    isExportDisabled,
    selectedSortOption: sortOptions.find((o) => o.id === tariffsSearchParams.sorting),
    sortOptions,
  };
};
